<template>
  <div class="card p-2">
    <div class="d-flex justify-content-between py-2 border-bottom">
      <div>
        {{ __('From Date') }}
        <span class="text-muted" :title="__('Select the start date for export')">
          ({{ __('Required') }})
        </span>
      </div>
      <div class="text-right">
        <ConstrainedDatePicker :date="this.fromDate" :mode="'from'" @update-date="updateFromDate" />
      </div>
    </div>
    <div v-if="this.fromDate" class="d-flex justify-content-between py-2 border-bottom">
      <div>
        {{ __('To Date') }}
        <span class="text-muted" :title="__('Select the end date for export')">
          ({{ __('Required') }})
        </span>
      </div>
      <div class="text-right">
        <ConstrainedDatePicker :date="this.toDate" :referenceDate="this.fromDate" :mode="'to'"
          @update-date="updateToDate" />
      </div>
    </div>
    <div class="d-flex justify-content-between py-2 border-bottom">
      <div>
        {{ __('Priority') }}
        <span class="text-muted" :title="__('Filter cases by priority')">(?)</span>
      </div>
      <div class="text-right">
        {{ filters.priority ? __(labelizePriority(filters.priority)) : __('All Priorities') }}
      </div>
    </div>
    <div class="d-flex justify-content-between py-2 border-bottom">
      <div>
        {{ __('Status') }}
        <span class="text-muted" :title="__('Filter cases by status')">(?)</span>
      </div>
      <div class="text-right">
        {{ filters.status ? __(labelizeStatus(filters.status)) : __('All Statuses') }}
      </div>
    </div>
    <div class="d-flex justify-content-between py-2 border-bottom">
      <div>
        {{ __('Type') }}
        <span class="text-muted" :title="__('Filter cases by type')">(?)</span>
      </div>
      <div class="text-right">
        {{ filters.type ? __(labelizeType(filters.type)) : __('All Types') }}
      </div>
    </div>
    <div class="d-flex justify-content-between py-2 border-bottom">
      <div>
        {{ __('Case Details') }}
        <span class="text-muted" :title="__('Filter cases by details')">(?)</span>
      </div>
      <div class="text-right">
        {{ filters.caseDetails ? __(labelizeCaseDetails(filters.caseDetails)) : __('All Cases') }}
      </div>
    </div>
  </div>
</template>

<script>
import ConstrainedDatePicker from '../generic/ConstrainedDatePicker.vue';


export default {
  components: {
    ConstrainedDatePicker,
  },

  props: {
    filters: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      fromDate: null,
      toDate: null,
    };
  },

  computed: {

  },

  methods: {
    updateFromDate(newDate) {
      this.fromDate = newDate;
      this.toDate = null;
      this.$emit('update-export-date-range', this.fromDate, this.toDate);
    },

    updateToDate(newDate) {
      this.toDate = newDate;
      this.$emit('update-export-date-range', this.fromDate, this.toDate);
    },

    resetDates() {
        this.fromDate = null;
        this.toDate = null;
        this.$emit('update-export-date-range', this.fromDate, this.toDate); 
    },

    labelizePriority(priority) {
      const labels = {
        '': __('All Priorities'),
        '0': __('Low'),
        '1': __('Medium'),
        '2': __('High'),
      };
      return labels[priority] || __(priority);
    },

    labelizeStatus(status) {
      const labels = {
        '': __('All Statuses'),
        'new': __('New'),
        'open': __('Open'),
        'closed': __('Closed'),
      };
      return labels[status] || __(status);
    },

    labelizeType(type) {
      const labels = {
        '': __('All Types'),
        'task': __('Task'),
        'issue': __('Issue'),
        'request': __('Request'),
      };
      return labels[type] || __(type);
    },

    labelizeCaseDetails(caseDetails) {
      const labels = {
        '': __('All Cases'),
        'withComments': __('With Comments'),
        'withoutComments': __('Without Comments'),
        'withAssignees': __('With Assignees'),
        'withoutAssignees': __('Without Assignees'),
        'withReviews': __('With Reviews'),
        'withoutReviews': __('Without Reviews'),
        'withSurveys': __('With Surveys'),
        'withoutSurveys': __('Without Surveys'),
        'request': __('Request'),
        'assignedCases': __('Assigned to me'),
      };
      return labels[caseDetails] || __(caseDetails);
    },
  },
};
</script>